import extractDefinitions from "../extractDefinitions";
import toArray from "../utils/toArray";
// I have no idea what this is meant to be as it's used as a component elsewhere
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Row = ({ children, ...rest }) => {
    return {
        columns: toArray(extractDefinitions(children)),
        ...rest
    };
};
export default Row;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUm93LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbXBvbmVudHMvUm93LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLGtCQUFrQixNQUFNLHVCQUF1QixDQUFDO0FBRXZELE9BQU8sT0FBTyxNQUFNLGtCQUFrQixDQUFDO0FBRXZDLGdGQUFnRjtBQUNoRiw4REFBOEQ7QUFDOUQsTUFBTSxHQUFHLEdBQUcsQ0FBQyxFQUFFLFFBQVEsRUFBRSxHQUFHLElBQUksRUFBa0IsRUFBTyxFQUFFO0lBQ3pELE9BQU87UUFDTCxPQUFPLEVBQUUsT0FBTyxDQUFDLGtCQUFrQixDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQzlDLEdBQUcsSUFBSTtLQUNSLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLEdBQUcsQ0FBQyJ9